import { HOST } from "../constants/HostConstants";

export const profilePromotionPurchase = async (user_id, impressions = 7500) => {
  try {
    const response = await fetch(`${HOST}/api/promotion/purchase`, {
      method: "POST",
      credentials: "include",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        user_id,
        impressions,
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || "Failed to purchase profile promotion");
    }

    return await response.json();
  } catch (error) {
    console.error("Error purchasing profile promotion:", error);
    throw error;
  }
};
